import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";

export const getPopoverChartData = (url: string) => {
  return axios.get(url).then((response) => {
    return response.data;
  });
};

export const useGetPopoverChartData = (url: string, config?: {}) => {
  return useQuery({
    queryKey: ["popover-chart-data"],
    staleTime: 1000 * 60 * 1,
    queryFn: () => getPopoverChartData(url) as any,
    ...(config as UseQueryOptions<unknown>)
  });
};
